/**
 * @documental
 * @export Option
 * @name
 * RadioGroup.Option
 */

import { FC, ReactNode } from "react";

/**
 * The `Option` component properties.
 */
export interface OptionProps {
  /**
   * The option value.
   */
  readonly value: string | number | boolean;

  /**
   * Indicates whether the radio button is disabled.
   */
  readonly disabled?: boolean;

  /**
   * The option childen.
   */
  readonly children?: ReactNode;
}

/**
 * A single option for the `RadioGroup` component.
 */
export const Option: FC<OptionProps> = () => {
  return null;
};
